import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessAnalisisPrecios } from '../utils/gestionCampanaAccess'

const RequireAnalisisPreciosAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessAnalisisPrecios(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireAnalisisPreciosAccess
